// extracted by mini-css-extract-plugin
export default {"ticketContainer":"m5nL9i","ticketInnerContainer":"s2kF5L","ticketInfoContainer":"mUk2gh","priceQuantityContainer":"DnttVp"};